import React, { useState, useEffect, useRef } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import moment from "moment/moment";
import "../pagination/pagination.css";
import Pagination from "../pagination/pagination";
import Select from "react-select";
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from "../../services/apiService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { ClipLoader } from 'react-spinners';
import { toast } from "react-toastify";
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import * as XLSX from "xlsx-js-style";

const clearedStatusList = [
    { label: "ALL", value: "ALL" },
    { label: "Cleared", value: "Cleared" },
    { label: "Uncleared", value: "Uncleared" },
];
const categoryList = [
    { label: "ALL", value: "ALL" },
    { label: "Receivable", value: "Receivable" },
    { label: "Payable", value: "Payable" },
];
const chequeDateOptions = [
    { label: "Posting Date", value: false },
    { label: "Cheque Date", value: true },
];

const PDCListReport = () => {
    const apiService = new LeaseApiService();
    const gridRef = useRef();
    const { currencyPrecision } = useCurrency();
    const [rowData, setRowData] = useState([]);
    const [exportData, setExportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(50);
    const [pagination, setPagination] = useState();
    const [FilterTab, setFilterTab] = useState(true);
    const [loader, setLoader] = useState(false);
    const [formData, setFormData] = useState({
        clearedStatus: clearedStatusList[0],
        category: categoryList[0],
        isChequeDate: chequeDateOptions[1],
        from: "",
        to: "",
    })
    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };
    useEffect(() => {
        const today = new Date();
        const fromDate = new Date(today);
        fromDate.setDate(today.getDate() - 30);

        setFormData((prev) => ({
            ...prev,
            from: formatDate(fromDate),
            to: formatDate(today),
        }));
    }, []);

    const dateFormatter = (params) => {
        if (!params.value) return '';
        const date = moment(params.value);
        return date.isValid() ? date.format('DD-MMM-YYYY') : '';
    };
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
    };
    const amountFormatter = (params) => {
        if (params?.value === null || params?.value === undefined) return '';
        return Number(params.value).toFixed(currencyPrecision?.decimalNumbers || 2);
    };
    const buildParams = (newPageNo, size) => {
        const today = new Date();
        const oneMonthBack = new Date(today);
        oneMonthBack.setDate(today.getDate() - 30);
        const params = new URLSearchParams();
        params.append("ClearedStatus", formData?.clearedStatus?.value || "ALL");
        params.append("Category", formData?.category?.value || "ALL");
        params.append("IsChequeDate", formData?.isChequeDate?.value ?? true);
        params.append("FromDate", formData?.from || formatDate(oneMonthBack));
        params.append("ToDate", formData?.to || formatDate(today));
        params.append("PageNo", newPageNo || 1);
        params.append("PageSize", size);
        return params;
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            setLoader(true)
            const params = buildParams(newPageNo, pageSize || 50);
            const res = await apiService.getApiParamater("REPORT_PDC_LIST", `?${params.toString()}`);
            if (res?.data?.result) {
                setRowData(res?.data?.result || []);
                setPagination(res.data.paginationData);
                getAllItems(res.data.paginationData)
                setLoading(false);
                setLoader(false)
            } else {
                setRowData(res?.data?.result || []);
                toast.error(res?.data?.message)
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            console.error("Error fetching items:", error);
            setLoader(false)
            setLoading(false);
        }
    }
    const getAllItems = async (total) => {
        try {
            const params = buildParams(1, total?.totalRecords);
            const res = await apiService.getApiParamater("REPORT_PDC_LIST", `?${params.toString()}`);
            if (res?.data?.result) {
                setExportData(res?.data?.result || []);
            }
        } catch (error) {
            console.error("Error fetching items:", error);
        }
    }
    const columnDefs = [
        { headerName: "Cleared Status", field: "clearedStatus", filter: true, floatingFilter: true, suppressMovable: true, width: 140, pinned: "left" },
        { headerName: "Category", field: "category", filter: true, floatingFilter: true, suppressMovable: true, width: 130, pinned: "left" },
        { headerName: "Voucher No", field: "voucherNo", filter: true, floatingFilter: true, suppressMovable: true, width: 130 },
        {
            headerName: "Posting Date", field: "postingDate", filter: true, floatingFilter: true, suppressMovable: true, width: 140,
            valueFormatter: dateFormatter,
            comparator: dateComparator,
        },
        { headerName: "Voucher Type", field: "voucherType", filter: true, floatingFilter: true, suppressMovable: true, width: 140 },
        { headerName: "Account Code", field: "accountCode", filter: true, floatingFilter: true, suppressMovable: true, width: 140 },
        { headerName: "Account Name", field: "accountName", filter: true, floatingFilter: true, suppressMovable: true, width: 200 },
        { headerName: "Adj Account Code", field: "adjAccountCode", filter: true, floatingFilter: true, suppressMovable: true, width: 150 },
        { headerName: "Adj Account Name", field: "adjAccountName", filter: true, floatingFilter: true, suppressMovable: true, width: 200 },
        {
            headerName: "Amount Debit", field: "amountDebit", filter: true, floatingFilter: true, suppressMovable: true, width: 140,
            valueFormatter: amountFormatter,
        },
        {
            headerName: "Amount Credit", field: "amountCredit", filter: true, floatingFilter: true, suppressMovable: true, width: 140,
            valueFormatter: amountFormatter,
        },
        { headerName: "Cheque No", field: "chequeNo", filter: true, floatingFilter: true, suppressMovable: true, width: 130 },
        {
            headerName: "Cheque Date", field: "chequeDate", filter: true, floatingFilter: true, suppressMovable: true, width: 140,
            valueFormatter: dateFormatter,
            comparator: dateComparator,
        },
        { headerName: "Narration", field: "narration", filter: true, floatingFilter: true, suppressMovable: true, width: 200 },
        { headerName: "Created By", field: "createdBy", filter: true, floatingFilter: true, suppressMovable: true, width: 130 },
        {
            headerName: "Created On", field: "createdOn", filter: true, floatingFilter: true, suppressMovable: true, width: 140,
            valueFormatter: dateFormatter,
            comparator: dateComparator,
        },
    ]
    const handleClearFilters = () => {
        setRowData([])
        const today = new Date();
        const fromDate = new Date(today);
        fromDate.setDate(today.getDate() - 30);
        setFormData({
            clearedStatus: clearedStatusList[0],
            category: categoryList[0],
            isChequeDate: chequeDateOptions[1],
            from: formatDate(fromDate),
            to: formatDate(today),
        });
    }
    const handleDropDownChange = ({ name, value }) => {
        setFormData(prev => ({ ...prev, [name]: value }));
    }
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value);
        let updatedDates = { ...formData, [name]: updatedValue };
        setFormData(updatedDates);
    }
    const normalizeValue = (value) => {
        if (value === null || value === undefined) return "";
        if (value === 0 || value === "0") return "";

        if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value)) {
            return moment(value).format("DD-MMM-YYYY");
        }

        return value;
    };
    const exportColumns = [
        { header: "Cleared Status", dataKey: "clearedStatus" },
        { header: "Category", dataKey: "category" },
        { header: "Voucher No", dataKey: "voucherNo" },
        { header: "Posting Date", dataKey: "postingDate" },
        { header: "Voucher Type", dataKey: "voucherType" },
        { header: "Account Code", dataKey: "accountCode" },
        { header: "Account Name", dataKey: "accountName" },
        { header: "Adj Account Code", dataKey: "adjAccountCode" },
        { header: "Adj Account Name", dataKey: "adjAccountName" },
        { header: "Amount Debit", dataKey: "amountDebit" },
        { header: "Amount Credit", dataKey: "amountCredit" },
        { header: "Cheque No", dataKey: "chequeNo" },
        { header: "Cheque Date", dataKey: "chequeDate" },
        { header: "Narration", dataKey: "narration" },
        { header: "Created By", dataKey: "createdBy" },
        { header: "Created On", dataKey: "createdOn" },
    ];
    const exportPDF = () => {
        if (!exportData?.length) return;

        const doc = new jsPDF("landscape", "pt", "A4");

        doc.setFillColor(110, 81, 153);
        doc.rect(0, 0, doc.internal.pageSize.width, 50, "F");

        doc.setTextColor(255);
        doc.setFontSize(16);
        doc.text("PDC List Report", 40, 32);

        doc.setFontSize(9);
        doc.text(
            `Period: ${formData?.from} to ${formData?.to}`,
            doc.internal.pageSize.width - 220,
            32
        );

        doc.setTextColor(0);

        doc.autoTable({
            startY: 60,
            head: [exportColumns.map(col => col.header)],
            body: exportData.map(row =>
                exportColumns.map(col => normalizeValue(row[col.dataKey]))
            ),
            styles: {
                fontSize: 8,
                cellPadding: 5,
                valign: "middle",
            },
            headStyles: {
                fillColor: [110, 81, 153],
                textColor: 255,
                fontStyle: "bold",
                halign: "center",
            },
            bodyStyles: {
                halign: "center",
            },
            alternateRowStyles: {
                fillColor: [240, 237, 245],
            },
            didDrawPage: data => {
                doc.setFontSize(8);
                doc.text(
                    `Page ${data.pageNumber}`,
                    doc.internal.pageSize.width / 2,
                    doc.internal.pageSize.height - 10,
                    { align: "center" }
                );
            },
        });
        doc.save("PDC_List_Report.pdf");
    };
    const exportExcel = () => {
        if (!exportData?.length) return;

        const title = "PDC LIST REPORT";

        // Reuse the grid's own column definitions (header + formatter) so the
        // export can never drift out of sync with what the grid shows.
        const columns = columnDefs.map(col => ({
            header: col.headerName,
            field: col.field,
            valueFormatter: col.valueFormatter,
        }));

        const dataRows = exportData.map(item =>
            columns.map(col =>
                col.valueFormatter
                    ? col.valueFormatter({ value: item[col.field], data: item })
                    : normalizeValue(item[col.field])
            )
        );

        const worksheet = XLSX.utils.aoa_to_sheet([
            [title],
            columns.map(c => c.header),
            ...dataRows,
        ]);

        // Merge Title
        worksheet["!merges"] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: columns.length - 1 } },
        ];

        // Auto column width
        worksheet["!cols"] = columns.map((col, i) => {
            const maxLength = Math.max(
                col.header.length,
                ...dataRows.map(r => String(r[i] ?? "").length)
            );
            return { wch: maxLength + 4 };
        });

        // Freeze header
        worksheet["!freeze"] = { ySplit: 2 };

        // Border style with color
        const borderStyle = {
            top: { style: "thin", color: { rgb: "FF000000" } },
            bottom: { style: "thin", color: { rgb: "FF000000" } },
            left: { style: "thin", color: { rgb: "FF000000" } },
            right: { style: "thin", color: { rgb: "FF000000" } },
        };

        // Title style
        const titleCell = worksheet["A1"];
        if (titleCell) {
            titleCell.s = {
                font: { bold: true, sz: 16, color: { rgb: "FF333333" } },
                alignment: { horizontal: "left", vertical: "center" },
                border: borderStyle,
            };
        }

        // Header style
        columns.forEach((_, c) => {
            const cell = worksheet[XLSX.utils.encode_cell({ r: 1, c })];
            if (!cell) return;

            cell.s = {
                font: { bold: true, sz: 11, color: { rgb: "FFFFFFFF" } },
                fill: { fgColor: { rgb: "FF6E5199" } },
                alignment: { horizontal: "center", vertical: "center" },
                border: borderStyle,
            };
        });

        // Data cells
        dataRows.forEach((row, r) => {
            columns.forEach((col, c) => {
                const cell = worksheet[XLSX.utils.encode_cell({ r: r + 2, c })];
                if (!cell) return;

                cell.s = {
                    font: { sz: 10, color: { rgb: "FF000000" } },
                    alignment: { vertical: "center", horizontal: "left" },
                    border: borderStyle,
                };
            });
        });

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "PDC List");
        XLSX.writeFile(workbook, "PDC_List_Report.xlsx");
    };
    return (
        <div className="p-3">
            <div className="cost-center-section">
                <div
                    className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}
                >
                    <div className="h6 pt-1">Search Parameters</div>
                </div>
                <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"}`}>
                        <div className="form-group grid-contain ">
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Cleared Status</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.clearedStatus}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'clearedStatus', value: selectedOption })}
                                    options={clearedStatusList}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Category</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.category}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'category', value: selectedOption })}
                                    options={categoryList}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Date Based On</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.isChequeDate}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'isChequeDate', value: selectedOption })}
                                    options={chequeDateOptions}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label">From</label>
                                <DatePicker
                                    selected={formData.from}
                                    onChange={(date) => handleDateChange({ name: 'from', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label w-0">To</label>
                                <DatePicker
                                    selected={formData.to}
                                    onChange={(date) => handleDateChange({ name: 'to', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100 datepicker-icon"
                                />
                            </div>
                            <div className="d-flex mt-2 gap-1">
                                {loader === true ?
                                    <div className='mainbtnGry flex-end gap-2 w-50'>
                                        <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                    </div>
                                    :
                                    <div
                                        onClick={() => getItems()}
                                        className="mainbtnGry flex-end gap-2 w-50"
                                    >
                                        <FaFileCircleExclamation
                                            color="#fff"
                                            className="center mt-2 mx-2"
                                        />
                                        <div className="center">Search</div>
                                    </div>
                                }
                                <div
                                    onClick={() => handleClearFilters()}
                                    className="mainbtnRed flex-end gap-2 w-50"
                                >
                                    <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                                    <div className="center">Reset</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="border-box2 p-3">
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <>
                        <div className="d-flex justify-content-between">
                            <h5 className="col mainInvHead">PDC List Report</h5>
                            <button className="btn btn-primary" onClick={exportPDF}>
                                Export as PDF
                            </button>
                            <button className="btn btn-secondary mx-3" onClick={exportExcel}>
                                Export as Excel
                            </button>
                        </div>

                        <div className="gridshad mt-3">
                            <div className="ag-theme-quartz" style={{ height: 650 }}>
                                <AgGridReact
                                    ref={gridRef}
                                    getRowStyle={(params) => (params.node.rowIndex % 2 === 0 ? { background: "#F0EDF5" } : { background: "#fff" })}
                                    rowData={rowData}
                                    enableFilter={true}
                                    floatingFilter={true}
                                    columnDefs={columnDefs}
                                />
                            </div>
                            <Pagination
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                pagination={pagination}
                                getItems={getItems}
                            />
                        </div>
                    </>
                )}
            </div>
        </div >
    );
};
export default PDCListReport;
